module.exports = __webpack_public_path__ + "assets/img/telegram.9404577e.svg";